export const OPEN_THANKS_MODAL = 'OPEN_THANKS_MODAL';
export const CLOSE_THANKS_MODAL = 'CLOSE_THANKS_MODAL';
